const userFields = {
  'Status Solutions': {
    'Status Solutions': ['legalFirstName','preferredFirstName','lastName','emailAddress','phoneNumber','userType','accessLevel'],
    Corporate: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','corporation','accessLevel'],
    Facility: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','facility','accessLevel','canCorrespond','groups'],
    Family: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','monitoredIndividualUsers']
  },
  Corporate: {
    Corporate: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','accessLevel']
  },
  Facility: {
    Facility: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','accessLevel','canCorrespond','groups'],
    Family: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress', 'phoneNumber','userType','monitoredIndividualUsers']
  },
  Family: {
    Family: ['legalFirstName', 'preferredFirstName', 'lastName', 'emailAddress','phoneNumber','monitoredIndividualUsers']
  }
}

export default userFields;